export enum StreamerWheelType {
  LOTTERY = 'lottery',
  WHEEL = 'wheel',
}

export type StreamerWheelMetadata = Record<string, string>;

export interface StreamerWheelModel {
  id: string;
  type: StreamerWheelType;
  name: string;
  image390Id: string;
  link: string;
  bonus: string;
  description: string;
  metadata: StreamerWheelMetadata;
  isActive: boolean;

  endDate?: string | null;
}
